import * as e from "react";
import { forwardRef as r } from "react";
const n = r(function(o, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...o
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM18.5882 12C18.5882 15.6386 15.6386 18.5882 12 18.5882C8.36142 18.5882 5.41176 15.6386 5.41176 12C5.41176 8.36142 8.36142 5.41176 12 5.41176C15.6386 5.41176 18.5882 8.36142 18.5882 12ZM12.7059 7.29412C12.7059 6.90427 12.3898 6.58824 12 6.58824C11.6102 6.58824 11.2941 6.90427 11.2941 7.29412V12V12.2924L11.5009 12.4991L13.8538 14.8521C14.1295 15.1277 14.5764 15.1277 14.8521 14.8521C15.1277 14.5764 15.1277 14.1295 14.8521 13.8538L12.7059 11.7076V7.29412Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as Clock
};
